import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { map, Observable } from 'rxjs';
import { ApiConstants } from '../base/api-constants';
import { HttpBaseService } from '../base/http-base.service';
import { AppGlobalService } from '../services/app.global.service';
import { getUser } from '../STORE/actions/auth.actions';
import { userData } from '../STORE/selectors/auth.selector';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  private baseService = inject(HttpBaseService);
  private router = inject(Router);
  private acRoute = inject(ActivatedRoute);
  private store = inject(Store);
  private appGlobalService = inject(AppGlobalService);

  routerAppId: any = '';
  routerOrgId: any = '';
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const user$: Observable<any> = this.store.select(userData);
    return user$.pipe(
      map((user: any) => {
        if (user?.email) {
          if (state.url) {
            const cleanUrl = state.url.split('?')[0].split('#')[0];
            const urlParams = cleanUrl.split('/');
            // cleanUrl typically starts with a slash, e.g., /home/orgId/appId/...
            if (urlParams.length > 2 && urlParams[1] === 'home') {
              this.routerOrgId = urlParams[2];
              this.routerAppId = urlParams[3];
            } else if (urlParams.length > 1 && urlParams[0] === 'home') {
              this.routerOrgId = urlParams[1];
              this.routerAppId = urlParams[2];
            }
          }
          const userInfo = user.orgIds || [];
          const orgId = this.appGlobalService.get('orgId');
          if (orgId && this.routerOrgId.includes('-')) {
            this.appGlobalService.write('orgId', this.routerOrgId);
            this.appGlobalService.write('invalidUrl', 'false');
          } else if (user) {
            this.appGlobalService.write('orgId', user?.orgIds[0]);
            this.appGlobalService.write('invalidUrl', 'true');
          }

          this.appGlobalService.write('appId', this.routerAppId);
          this.appGlobalService.write('appRole', localStorage.getItem('appRole'));
          return true;
        }

        // Pass original url to login so we can redirect back after authentication
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } }).catch((error) => {
          console.error(error);
        });
        return false;
      })
    );
  }
}
